import { render, staticRenderFns } from "./LeafIcon.vue?vue&type=template&id=1257de89&"
import script from "./LeafIcon.vue?vue&type=script&lang=js&"
export * from "./LeafIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports